<template>

<div class="sidebar">

    <router-link :to="{name: 'Onboard'}" class="sidebar-item is-home" v-tooltip.right="'Return to home'" />

    <router-link :to="{name: 'Report.Data'}" class="sidebar-item" v-tooltip.right="'Manage the datasets'">

        <icon n="report_data" />

    </router-link>

    <router-link :to="{name: 'Report.Cards'}" class="sidebar-item" v-tooltip.right="'Analytics'">

        <icon n="report_cards" />

    </router-link>

    <router-link :to="{name: 'Report.Map'}" class="sidebar-item" v-tooltip.right="'Map view'">

        <icon n="report_map" />

    </router-link>

</div>

</template>

<script>

export default {
	
    props: []

}

</script>

<style scoped>

.sidebar {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 104px;
    bottom: 0px;
    background-color: #1A4860;
    z-index: 2;
    padding: 32px 28px;
}

.sidebar-item {
    width: 48px;
    height: 48px;
    background-color: #14C6A4;
    line-height: 52px;
    text-align: center;
    font-size: 24px;
    color: #fff;
    display: block;
    border-radius: 50%;
    margin-bottom: 20px;
}

.sidebar-item.is-home {
    margin-bottom: 64px;
    background-color: #000;
    background-position: 50% 50%;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAYFBMVEUAAAD////4+PgSEhIzMzPw8PAMDAzl5eXe3t7X19d7e3vLy8vAwMBQUFAjIyM+Pj6hoaFycnJtbW0dHR2ysrKIiIgpKSlLS0uxsbGZmZmPj4+CgoJiYmJaWlrFxcVFRUWPn7SBAAADNklEQVRo3u2Z2XbbIBBAWYQAgbXviu3//8vW7UlpzIAZyc1LdR9ychLCZYYBjxRycnJycvIu8mxqh7q/aaOUMf1SXMr3Cvi96BWjTwjbvM1Tfszic14nYr+/1uM7knSZhZsUgG350TQVmkZ5uG13SNEoF0JEow/szIdyhjia71RkFowCjqXf5ygYYJDGaAF6PnYoOutHIYeK/ypoDW0LvsQq5c8z8D9VXVOfK9ZxARI1EUdu/FBmbFX5qVLj11X4+6U40uEhx6cDpPwx2UEHuz8Psv6gCeG4Up/GG9VT9rwpLaKugONnCXkdCUJSSiBZfrZzfUCS34BjvgJXjr+S9IMyUB9RAncOMK5KdEzUEQuEK3AtEFCmWVL9b9THHEgWdInfoct+TXOMAvrjD3/XJd2/JTUFkBxwgGcpiYxBktkrDigOlnqpLDQlWwUFqRE74lvGr9HeYIfqXgvcEqOFWS6MMihclnoQoTPC6PJXFIugMGxKvX0pSPsZRGtZqEESE+bWgi/gvLwMVoS7YZP+kWjAKdi2WM2cAGDNkx0ji3aIwR/fKvSHLlg5Ea/BNVtDaLKwgvUTwdFj5n9gtoxg0a/ndiUs+yYjeDpB05Cmbu5857NIaP0PhJBK3/p6aKcMnP/YeZfZ+JOOc56T41wCkujC8RL2HRIQ0X2DhGXvT9fexwFc64hvoo+XMKM1PidX9GHUSMVY0y34Sy4DFtTOZzWjtIh9MMKsiFdW/SPDMUntlRfuwblrPu/xiKShAbakIGa3xIjkHpKI7OVODMoNj6aLq5DFRBNWNrenRqPAPDe4lyZ5cGXXWTiFiyR+scDYEj7AK/jusIg/LwYRDffTZCikYPFKKSgL9ydqy1zSeNZYEWr5dBatdBlvg/S8Nm3bFotV4a5SFDmJ0sB/B83I4BFy7V4eKZPSeYVXIrcO/4II11OaluOe6PCa/pLeM9W7gtDDSBDkFq1g8xXb+HGL3ImiJHj4DBUorFBLRXYyeBb4TNQXfqQHU6/juB3+XxYfRDQavb2lsSxX+fX6cN+r5Z6TN8Gvs/QvDltUcQPeU7WL1VI8UKZf24qTf0Te/YSTk5OTk/+IH+ggJETQnMJ+AAAAAElFTkSuQmCC);
}

.sidebar-item:hover {
    background-color: #0faf91;
}

.sidebar-item.router-link-exact-active {
    background-color: #1778FB;
}

</style>
